import Vue from "vue"
import Vuex from 'vuex'
import App from "./components/app.vue"

const init = () => {

	const container = document.getElementById('candidate-search');

	if (document.body.contains(container)) {

		Vue.use(Vuex)

		// Get url segments and params
		const urlSegs   = window.location.pathname.split("/")
		const urlParams = new URLSearchParams(window.location.search)

		const selectedSectors = []
		if (typeof urlSegs[2] !== undefined && urlSegs[2] !== 'all') {
			const result = sectors.find( ({ slug }) => slug === urlSegs[2] )
			if (result !== undefined) {
				selectedSectors.push(result.value)
			}
		}

		// Set default selected job types if in url
		const selectedJobTypes = []
		if (typeof urlSegs[3] !== undefined && urlSegs[3] !== 'all') {
			const result = jobTypes.find( ({ slug }) => slug === urlSegs[3] )
			if (result !== undefined) {
				selectedJobTypes.push(result.value)
			}
		}

		// Set default selected regions from query string
		const selectedRegions = []
		if (urlParams.get('regions') !== null) {
			for (const regionSlug of urlParams.get('regions').split(',')) {
				selectedRegions.push(regionSlug)
			}
		}

		const selectedLocations = []
		if (urlParams.get('locations') !== null) {
			for (const locationId of urlParams.get('locations').split(',')) {
				selectedLocations.push(locationId)
			}
		}
		const selectedTerms = []
		if (urlParams.get('terms') !== null) {
			for (const term of urlParams.get('terms').split('|')) {
				selectedTerms.push(term)
			}
		}

		function filtersKeyByType(type) {

			let result = type

			switch(type) {
				case 'location':
					result = 'locations'
					break
				case 'term':
					result = 'terms'
					break
			}

			return result
		}

			function updateUrlWithFilters(selected, groups) {

				const sectorId  = selected.sectors[0]
				const jobTypeId = selected.jobTypes[0]

				const sector  = groups[0].options.find(o => {return o.value === sectorId})
				const jobType = groups[1].options.find(o => {return o.value === jobTypeId})

				const sectorSlug  = (sector !== undefined) ? sector.slug : 'all'
				const jobTypeSlug = (jobType !== undefined) ? jobType.slug : 'all'

				let arrUrl = [container.getAttribute('data-page')]

				if (sectorSlug !== 'all' || jobTypeSlug !== 'all') {
					arrUrl = arrUrl.concat([
						sectorSlug,
						jobTypeSlug
					])
				}

				let url       = '/' + arrUrl.join('/')
				let arrParams = []

				// Check for regions
				if (selected.regions && selected.regions.length) {
					arrParams.push('regions=' + selected.regions.join(','))
				}
				// Check for locations
				if (selected.locations.length) {
					arrParams.push('locations=' + selected.locations.join(','))
				}
				if (selected.terms.length) {

					const arrTerms = []
					for (const j of selected.terms) {
						arrTerms.push(encodeURIComponent(j))
					}

					arrParams.push('terms=' + arrTerms.join('|'))
				}

				if (arrParams.length) {
					url += '?' + arrParams.join('&')
				}

				history.pushState({}, '', url)
			}

		const store = new Vuex.Store({
			state: {
				filterGroups: [
					{
						id: 1,
						title: 'Job Function',
						key: 'sectors',
						options: sectors
					},
					{
						id: 2,
						title: 'Job Types',
						key: 'jobTypes',
						options: jobTypes
					},
					{
						id: 3,
						title: 'Region',
						key: 'regions',
						options: regions
					}
				],
				locations: locations,
				candidates: candidatesData,
				selectedFilters: {
					sectors: selectedSectors,
					jobTypes: selectedJobTypes,
					regions: selectedRegions,
					locations: selectedLocations,
					terms: selectedTerms
				},
				perPage: 6,
				currentPage: 1,
				filteringBy: null
			},
			getters: {
				isFiltering: state => {
					let num = 0
					for (const p in state.selectedFilters) {
						num = num + state.selectedFilters[p].length
					}

					return (num > 0)
				},
				filteredCandidates: (state, getters) => {
					let arr = state.candidates

					if (getters.isFiltering) {
						// Filter by selected locations
						let candidatesWithLocations = []
						for (const f of state.selectedFilters.locations) {
							let arr2 = state.candidates
							arr2 = arr2.filter((item) => {return item.locations.includes(f)})

							for (const j of arr2) {
								if (candidatesWithLocations.includes(j.id) === false) {
									candidatesWithLocations.push(j.id)
								}
							}
						}

						if (candidatesWithLocations.length) {

							let arrNew = []

							for (const j of candidatesWithLocations) {
								const result = arr.find( ({id}) => id === j)
								arrNew.push(result)
							}

							arr = arrNew
						}

						// Filter by selected candidate titles
						for (const f of state.selectedFilters.terms) {
							const fLower = f.toLowerCase()
							arr = arr.filter((item) => {
								const t = item.title.toLowerCase()
								return t.includes(fLower)
							})
						}

 					// Filter by selected sectors
 					for (const f of state.selectedFilters.sectors) {
 						arr = arr.filter((item) => {return item.sectors.includes(f)})
 					}

 					// Filter by selected regions
 					if (state.selectedFilters.regions && state.selectedFilters.regions.length) {
 						for (const f of state.selectedFilters.regions) {
 							arr = arr.filter((item) => {return item.regions.includes(f)})
 						}
 					}

 					// Filter by selected candidate types
 					for (const f of state.selectedFilters.jobTypes) {
 						arr = arr.filter((item) => {return item.jobTypes.includes(f)})
 					}

 					return arr

					}

					return arr
				}
			},
			mutations: {
				filterSelect (state, data) {

					switch(data.type) {
						case 'location':
						case 'term':
							state.selectedFilters[filtersKeyByType(data.type)].push(data.value)
							break

						default:
							state.selectedFilters[filtersKeyByType(data.type)] = [data.value]
					}

					// state.selectedFilters[filtersKeyByType(data.type)].push(data.value)
					state.currentPage = 1
					state.filteringBy = data.type

					updateUrlWithFilters(state.selectedFilters, state.filterGroups)
				},
				filterRemove (state, data) {
					const itemIndex = state.selectedFilters[filtersKeyByType(data.type)].indexOf(data.value)
					~itemIndex && state.selectedFilters[filtersKeyByType(data.type)].splice(itemIndex, 1)
					state.currentPage = 1

					state.filteringBy = null

					updateUrlWithFilters(state.selectedFilters, state.filterGroups)
				},
				pageChange (state, page) {
					state.currentPage = page
				}
			},
		})

		Vue.mixin({
			methods: {
				iconByType: function(type) {
					switch (this.type) {
						case 'location':
							return 'map-marker-alt'
						case 'term':
							return 'user'
					}
				}
			}
		});

		new Vue({
			el: '#candidate-search',
			store: store,
			render: function (createElement) {
				return createElement(App)
			}
		});

	}
}

export default init
